<template>
    <div>
        <header :class="{'full-width' : $route.meta.hideSideNavigation}">
            <b-navbar toggleable
                      :class="[{ 'navbar-cover': $route.meta.isCoverPage }]"
                      v-if="$route.meta.showNavigation">
                <div v-if="$route.meta.showNavigationInfo" class="navbar-item-left">
                    <b-button class="button-home" variant="default" size="lg" @click="$router.push({ name: 'home' })">
                        <span :class="[isJACareerEntrepreApp ? 'green-dark' : 'green-light']" class="icon icon-home"></span>
                        <span class="label-exit">Exit</span>
                    </b-button>
                </div>
                <div ref="navbarProgress" v-if="$route.meta.showNavigationInfo && $route.meta.pageNumber && $route.meta.title"
                     class="navbar-item-center" tabindex="0"
                     :aria-label="getBrandAriaLabel()">
                    <div class="page-number">{{ $route.meta.pageNumber }}</div>
                    <div class="page-theme">{{ $route.meta.title }}</div>
                    <div class="page-progress"></div>
                    <div class="page-progress-fill" :style="{width: progressBarPercentage}"></div>
                </div>
                <div v-if="!$route.meta.showNavigationInfo" class="navbar-item-left-logo" tabindex="0">
                    <img v-if="isJAUSCareerEntrepreApp"
                         src="../Images/ja_logo.svg" class="img-logo" alt="Junior Achievement">
                    <img v-if="isIntuitApp"
                         src="../Images/intuit_logo.svg" class="intuit-logo img-logo" alt="Design for Delight by INTUIT">
                </div>

                <focus-trap v-model="navigationIsOpen" :initial-focus="() => $refs.homeLink">
                    <div style="display: contents">
                        <div class="navbar-item-right">
                            <b-navbar-toggle ref="menuToggle" class="navbar-toggler" target="navbar-toggle-collapse"
                                            @click="onClickToggle">
                                <span class="icon closer-icon"></span>
                                <span class="icon toggler-icon"></span>
                            </b-navbar-toggle>
                        </div>
                        <b-collapse id="navbar-toggle-collapse" is-nav>
                            <hr class="divider"/>
                            <b-navbar-nav>
                                <b-nav-item ref="homeLink" @click="goHome" @keypress.space="goHome">
                                    <span class="item-content item">Home</span>
                                </b-nav-item>
                                <b-nav-text class="section" v-if="!isJAUSCareerEntrepreApp">
                                    <span class="item-content item-section">User Settings</span>
                                </b-nav-text>
                                <b-nav-item class="item-three" @click="goChangePassword" @keypress.space="goChangePassword"  v-if="!isJAUSCareerEntrepreApp">
                                    <span class="item-content item ">Change Password</span>
                                </b-nav-item>
                                <b-nav-text class="section">
                                    <span class="item-content item-section">Accessibility Settings</span>
                                </b-nav-text>
                                <b-nav-text class="high-contrast-mode" v-if="!isJACareerEntrepreApp">
                                        <span class="item-content item">
                                            High Contrast Mode
                                        </span>
                                    <b-form-checkbox class="ml-4" switch size="lg"
                                                    v-model=settings.highContrast
                                                    aria-label="High Contrast Mode"
                                                    v-on:change="onChangeSettings"
                                    />
                                </b-nav-text>
                                <b-nav-text class="divider-two"></b-nav-text>
                                <b-nav-text class="font-size-content">
                                        <span class="item-content item">
                                            Font Size
                                        </span>
                                    <span class="item-font-size">
                                            <b-button class="font-button mr-2" @click="add(-25)" variant="link"
                                                    :disabled="settings.fontSize === 100"
                                                    aria-label="Decrease font size">
                                                <span class="icon less-menu"/>
                                            </b-button>
                                            <span>{{ settings.fontSize }}%</span>
                                            <b-button class="font-button ml-2" @click="add(25)" variant="link"
                                                    :disabled="settings.fontSize === 200"
                                                    aria-label="Increase font size">
                                                <span class=" icon more-menu"/>
                                            </b-button>
                                        </span>
                                </b-nav-text>
                                <b-nav-text class="section-blank"></b-nav-text>
                                <b-nav-item @click="logout" @keypress.space="logout">
                                    <span class="item-content item">Log Out</span>
                                </b-nav-item>
                            </b-navbar-nav>
                        </b-collapse>
                    </div>
                </focus-trap>
            </b-navbar>
            <online-offline>
                <div class="content-offline" slot="offline" >
                    No internet Connection <span class="icon icon-warning"></span>
                </div>
            </online-offline>
        </header>
    </div>
</template>

<script>
    import {FocusTrap} from 'focus-trap-vue'
    import {AuthService, UserService} from '../../modules/Security/Services'
    import OnlineOffline from "./OnlineOffline"
    import {Storage, Spinner, Zoom} from '../Utils'

    export default {
        name: 'AppHeader',
        components: {
            OnlineOffline,
            FocusTrap
        },
        data() {
            return {
                navigationIsOpen: false,
                progressBarPercentage: 0,
                settings: {
                    id: null,
                    language: "en",
                    highContrast: false,
                    fontSize: 100,
                },
            }
        },
        watch: {
            '$route': function (value) {
                this.$nextTick(()=>{
                    this.progressBarPercentage = this.getProgressBarWidth(this.$refs.navbarProgress?.clientWidth) + '%'
                })
            },
             '$route.meta': {
                handler: function(meta) {
                    if(this.isJACareerEntrepreApp && (this.$route.name === 'js_start_project' || this.$route.name === 'js_edit_project' ||
                        this.$route.name === 'be_start_project' || this.$route.name === 'be_start_project')) {
                        this.$route.meta.showNavigation = true
                    }
                },
                deep: true,
                immediate: true
      }
        },
        methods: {
            getProgressBarWidth(progressBarWidth = 0){
                if (this.$route.meta?.pageNumber && progressBarWidth) {
                    const [page, , total] = this.$route.meta.pageNumber.split(' ')
                    const pageNumber = Number.parseInt(page)
                    const totalNumber = Number.parseInt(total)

                    if (!Number.isNaN(pageNumber) && !Number.isNaN(totalNumber)) {
                        return (((progressBarWidth / totalNumber * pageNumber) / progressBarWidth) * 100).toFixed(2)
                    }

                    return 0
                }

                return 0
            },
            goHome(e) {
                if (this.$router.currentRoute.name === 'home') {
                    this.$refs.menuToggle.onClick(e)
                } else {
                    this.$router.push({name: 'home'})
                }
            },
            goChangePassword(e) {
                this.$router.push({name: 'ChangePassword'})
            },
            onClickToggle(e) {
                if (!this.$refs.menuToggle.toggleState) {
                    const unwatch = this.$watch(
                        () => {
                            return this.$refs.menuToggle.toggleState
                        },
                        (val) => {
                            this.navigationIsOpen = val
                            if (!val) {
                                unwatch()
                            }
                        }
                    )

                }
            },
            logout() {
                const user = Storage.getUser()
                AuthService.logout()
                Zoom.setAppZoom(100)

                if(this.isJACareerEntrepreApp) {
                    this.$router.push({name: 'Login'})
                } else if (user.isExternalLogin) {
                    this.$router.push({name: 'SSOLogout'})
                } else {
                    this.$router.push({name: 'Login'})
                }
            },
            onChangeSettings() {
                if (this.isGuest) {
                    Spinner.start()
                    let user = Storage.getUser()
                    user.language = this.settings.language
                    user.highContrast = this.settings.highContrast
                    user.fontSize = this.settings.fontSize
                    Storage.setUser(user)                    
                    this.$emit('settings-change', this.settings)
                    Spinner.stop()
                }
                else {
                    Spinner.start()
                    UserService.saveSettings(this.settings).then(response => {
                        Spinner.stop()
                        let user = Storage.getUser()
                        user.language = response.user.language
                        user.highContrast = response.user.highContrast
                        user.fontSize = response.user.fontSize
                        Storage.setUser(user)
                        this.$emit('settings-change', this.settings)
                    }).catch(err => {
                        Spinner.stop()
                    })
                }
            },
            add(delta) {
                const newFontSize = this.settings.fontSize + delta
                if (newFontSize >= 100 && newFontSize <= 200) {
                    Spinner.start()
                    this.settings.fontSize = newFontSize
                    Zoom.setAppZoom(newFontSize)
                    this.onChangeSettings()
                }
            },
            getBrandAriaLabel() {
                if (this.$route.meta.showNavigationInfo) {
                    return `${this.$route.meta.title} step ${this.$route.meta.pageNumber}`
                }
                return ''
            }
        },
        mounted() {
            const user = Storage.getUser()
            this.settings = {...user}

            this.$nextTick(() =>{
                this.progressBarPercentage = this.getProgressBarWidth(this.$refs.navbarProgress?.clientWidth) + '%'
            })
        },

    }

</script>

<style lang="stylus" scoped>
    @import "~@/core/Styles/mixins.styl"
    @import "~@/core/Styles/variables.styl"

    +for_breakpoint(xs sm md )
        .intuit-logo
            width 180px
        .font-size
            .img-logo
                margin-left 5px
                width 90px !important

    +for_breakpoint(xs )
        .font-size
            .nav-link
                padding:0
           .navbar-collapse
               .section-blank
                    padding-top: 0 !important
    .font-size
        .img-logo
           margin-left 5px
           width 150px
        .navbar-collapse
            .item-content
                margin-left 0px !important
                white-space: normal;
    .img-logo
        margin-left 16px
        width 114px

    .content-offline
        background-color color-7
        font font-poppins-semibold
        font-size 14px
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0.4rem;

        .icon
            padding-left 10px


    .navbar
        min-height: 64px
        background-color: white
        box-shadow(0 2px 5px 0 color-19)
        padding 0.5rem

    +for_breakpoint(xs sm md)
        .navbar
            &-cover
                display none

    +for_breakpoint(lg xl)
        .navbar
            &-cover
                display flex
                background transparent
                box-shadow none

        img
            padding-top 5px

    header
        position fixed
        z-index 1000
        width 100%

        .navbar-toggler
            border 0
            padding-right 21px   !important
            padding-left 0  !important

            &:focus
                border 0
                outline none !important

            &.not-collapsed
                .icon
                    &.closer-icon
                        display block

                    &.toggler-icon
                        display none

            .icon
                &.toggler-icon
                    content url("../Images/nav_icon.svg")

                &.closer-icon
                    content url("../Images/icon-close.svg")
                    display none

    +for_breakpoint(lg xl)
        header
            width 75%

            &.full-width
                width 100%

    .navbar-item-left-logo
        display block

    +for_breakpoint(xs sm md)
        .navbar-item-left-logo
            padding-top: 10px;
            padding-bottom: 10px;

    .navbar-item-left
        display none

    +for_breakpoint(lg xl)
        .navbar-item-left
            display block

            button
                display inline-block
                vertical-align middle
                font-size 14px
                padding 0

                .label-exit
                    font-size 14px
                    font-weight 600
                    padding-left 5px
                    padding-top 3px
                    text-decoration underline
                    color color-4

    .navbar-collapse
        background-color color-blank
        overflow-x: auto
        overflow-y: hidden
        white-space: nowrap
        height calc(100vh - 64px)

        .navbar-text
            display: flex;
            align-items: center;
            justify-content: space-between;

        .section-blank
            padding-top 24px
            background-color #F4F6F6

        .custom-control
            float right
            padding-right 15px

        .item-font-size
            float right
            padding-right 24px
            font font-sourcesans-regular !important
            font-size 16px !important
            color #666666
            margin-left 24px

        .divider
            margin 0
            border: 1px solid #DEEAF2;

        .divider-two
            background-color #DEEAF2
            margin-bottom 0 !important
            margin-left 12px
            margin-right 10px
            border: 2px solid #DEEAF2;
            padding 0

        .color-item
            background-color #F4F6F6

        .item
            font font-poppins-semibold !important
            font-size 14px !important
            color color-black

        .item-content
            margin-left 20px !important

        .item-three
            padding-top 2px

        .item-section
            font font-sourcesans-semibold !important
            font-size 14px !important
            color #666666

        .section
            background-color #F4F6F6
            padding-top 11px

        .font-size-content
            .icon
                &.less-menu
                    content url("../Images/less-menu.svg")

                &.more-menu
                    content url("../Images/more-menu.svg")

    +for_breakpoint(lg xl)
        .navbar-collapse
            position fixed
            right 0
            top 64px
            background-color color-blank
            border-width 0 0 0 2px
            border-color color-19
            border-style solid
            z-index 1000

    .navbar-item-center

        .page-number
            font-family: 'Source Sans Pro', sans-serif
            font-size: 11px
            font-weight: 600;
            color: color-8
            text-align left

        .page-theme
            font-family: 'Poppins', sans-serif
            font-size: 14px
            font-weight: 600
            color: color-black

        .page-progress
            border: solid 1px color-7
            margin-top: 5px
            border-radius: 25px

        .page-progress-fill
            border: solid 2px color-9
            border-radius: 25px
            position: relative
            top: -3px

    .font-size
        .navbar-item-center
            width 15vh

    +for_breakpoint(lg xl)
        .navbar-item-center
            width 38vh
            .page-number
                text-align center
        .font-size
            .navbar-item-center
                width 30vh

    .button-home
        display flex

</style>
